module.exports = __webpack_public_path__ + "media/images/wfc/venue-4-e5106e66031dadc3eb24514828858ebc.jpg";